import { graphql } from 'gatsby';
import React, { FC } from 'react';
import { HomepageFragment } from '../../../../types/graphqlTypes';
import { CTACard } from '../../../CtaCard';
import { Grid } from '../../../Grid';
import { Panel } from '../../../Panel';
import { HeroSearch } from '../../../search/HeroSearch';

export const Homepage: FC<HomepageFragment> = ({ valuationHeading, valuationLeadText, button }) => (
  <Grid desktopColumns="2">
    <Panel backgroundColor="white" shadow heading="Find a property" headingComponent="h2">
      <HeroSearch />
    </Panel>
    <CTACard backgroundColour="brand" shadow title={valuationHeading} lead={valuationLeadText} button={button} />
  </Grid>
);

export const HomepageQuery = graphql`
  fragment Homepage on KFH_UmbracoHomepageComponentType {
    valuationHeading
    valuationLeadText
    button {
      ...Button
    }
  }
`;
